import type { FC } from 'react'
import React from 'react'

import Divider from '@vfuk/core-divider'
import Image from '@vfuk/core-image'
import { useBreakpoints } from '@vfuk/core-match-media'
import { getDataSelector } from '@vfuk/core-base-props'

import * as Styled from './styles/PartnerLinks.style'

import type { PartnerLinksProps } from './PartnerLinks.types'

import { useLinksList } from '../../hooks'

const PartnerLinks: FC<PartnerLinksProps> = ({
  partnerLinks,
  onInteractionClick,
  appearance = 'primary',
  footerTheme,
  dataSelectorPrefix,
}) => {
  const { sm } = useBreakpoints()

  const getLinksRowLength = (): 2 | 4 => {
    if (sm) return 2

    return 4
  }

  const linksList = useLinksList(partnerLinks!, getLinksRowLength())

  const { dividerAppearance, inverseDivider } = footerTheme.appearance[appearance]

  return (
    <Styled.PartnerLinks data-selector={getDataSelector(dataSelectorPrefix)}>
      {linksList!.map((row, rowIndex) => {
        return (
          <Styled.LinksRow
            key={`footer-partner-links-list-${rowIndex}`}
            dataSelectorPrefix={getDataSelector(dataSelectorPrefix, `row-${rowIndex}`)}
          >
            <Styled.RowListGroup>
              {row?.map((link, linkIndex) => {
                return (
                  <Styled.ListItemWrapper key={link.id}>
                    <Styled.InteractionWrapper
                      href={link.href}
                      customRouterProps={link.customRouterProps}
                      onClick={onInteractionClick}
                      dataAttributes={link.dataAttributes}
                      footerTheme={footerTheme}
                      appearance={appearance}
                    >
                      {link.image && (
                        <Image
                          sm={{ src: link.image! }}
                          alt={link.srText || link.text}
                          dataSelectorPrefix={getDataSelector(dataSelectorPrefix, `link-${linkIndex}-image`)}
                        />
                      )}
                      {link.text}
                    </Styled.InteractionWrapper>
                    {linkIndex !== row.length - 1 && (
                      <Divider appearance={dividerAppearance} orientation='vertical' inverse={inverseDivider} />
                    )}
                  </Styled.ListItemWrapper>
                )
              })}
            </Styled.RowListGroup>
          </Styled.LinksRow>
        )
      })}
    </Styled.PartnerLinks>
  )
}

export default PartnerLinks
